// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__42j0U","questions":"styles_questions__1o--Y","footer":"styles_footer__RM29J"};